// extracted by mini-css-extract-plugin
module.exports = {"blank":"blank--18539"};